import React, { Component } from 'react';
import Label from 'components/connectedForm/Label';
import styled from 'styled-components';
import widthMixin from 'styles/utils/widthMixin';

const LabelContainer = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  padding: 2px 16px;
`;

const LabelBlock = styled.div`
  ${widthMixin}
  display: inline-block;
`;

export default class OverviewLabel extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      alignLabel,
      bold,
      id,
      label,
      includeLabel,
      flexBox,
      labelCols,
      labelAddon,
      uppercaseLabel,
      verticalAlign,
    } = this.props;

    const labelProps = {
      bold,
      flexBox,
      id,
      includeLabel,
      label,
      labelAddon,
      alignLabel,
      uppercaseLabel,
      verticalAlign,
    };

    return (
      <LabelContainer list={this.props.list}>
        <LabelBlock cols={labelCols}>
          <Label {...labelProps} view={true} bold={bold}>
            {label}
          </Label>
        </LabelBlock>
      </LabelContainer>
    );
  }
}
